import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
interface Product {
  name: string;
  price: string;
  image: string;
  hasConfigurator?: boolean;
  href?: string;
}
export function DaedoPSSSystemPage() {
  const products: Product[] = [{
    name: 'Gen3 PSS-Gloves USAT',
    price: '$69.00',
    image: 'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png',
    hasConfigurator: true
  }, {
    name: 'Gen3 E-Foot Gear',
    price: '$110.84',
    image: 'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg',
    hasConfigurator: true,
    href: '#product-gen3-efoot'
  }, {
    name: 'Gen2 Transmitter Charger',
    price: '$55.00',
    image: 'https://cdn.magicpatterns.com/uploads/qEV6XsHhowYMSa1F9qrPwc/Gen2_Transmitter_Charger.jpg',
    hasConfigurator: false
  }, {
    name: 'Gen2 W.T. Software',
    price: '$99.00',
    image: 'https://cdn.magicpatterns.com/uploads/orVwRQoYnnfYKgyRtLXkKq/Gen2_W.T._Software.jpg',
    hasConfigurator: false
  }, {
    name: 'Gen2 Judge Box (Refurbished) Same Warranty',
    price: '$580.00',
    image: 'https://cdn.magicpatterns.com/uploads/bS347spy52LoYXHH7zr4qL/Gen2_Judge_Box_(Refurbished)_Same_Warranty.jpg',
    hasConfigurator: false
  }, {
    name: 'Gen2 Receiver',
    price: '$390.00',
    image: 'https://cdn.magicpatterns.com/uploads/w3Q65FCerZEu2ek6y4Xdyo/Gen2_Receiver.jpg',
    hasConfigurator: false
  }, {
    name: 'Gen2 E-HeadGear',
    price: '$399.00',
    image: 'https://cdn.magicpatterns.com/uploads/oEDj2ZvCJJBgsVECUR8bR3/Gen2_E-HeadGear.jpg',
    hasConfigurator: true
  }, {
    name: 'Gen2 Head Transmitter',
    price: '$390.00',
    image: 'https://cdn.magicpatterns.com/uploads/keKg2f8ApxK9KnFdbJLkPa/Gen2_Head_Transmitter.jpg',
    hasConfigurator: false
  }, {
    name: 'Gen2 Chest Transmitter',
    price: '$390.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2F6-300x300.jpg',
    hasConfigurator: false
  }, {
    name: 'Gen2 E-Chest Gear Adult Size',
    price: '$775.00',
    image: 'https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg',
    hasConfigurator: true,
    href: '#product-gen2-echest'
  }, {
    name: 'Gen2 E-Foot Gear',
    price: '$95.00',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FDaedo%2FGeneration2%2Fepro29037_1_optimizacionweb.jpg',
    hasConfigurator: true
  }, {
    name: 'Daedo Truescore E-Foot Gear Magnet Tester',
    price: '$9.99',
    image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2Fdaedo-e-footgear-magnet-tester.jpg',
    hasConfigurator: false
  }];
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-362">
      <Header data-id="element-363" />

      <main className="flex-grow pt-32 pb-20" data-id="element-364">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-365">
          {/* Daedo Logo Section */}
          <div className="text-center mb-12" data-id="element-366">
            <div className="inline-flex items-center justify-center mb-6" data-id="element-367">
              <div className="w-16 h-16 bg-gray-900 rounded-full flex items-center justify-center" data-id="element-368">
                <span className="text-white font-bold text-2xl" data-id="element-369">D</span>
              </div>
              <span className="ml-3 text-4xl font-black text-gray-900" data-id="element-370">
                Daedo
              </span>
            </div>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-371">
              Shop the Daedo TrueScore PSS System at TKDScore, featuring the
              latest{' '}
              <span className="font-bold" data-id="element-372">
                Gen 3 Taekwondo scoring equipment
              </span>{' '}
              along with essential{' '}
              <span className="font-bold" data-id="element-373">
                Gen 2 products and replacement parts
              </span>{' '}
              for schools, clubs, and tournaments.
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-374">
            {products.map((product, index) => <div key={index} className="flex items-start gap-6 p-6 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-shadow" data-id="element-375">
                {/* Product Image */}
                <a href="#product-gen3-efoot" className="flex-shrink-0 w-24 h-24 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden hover:opacity-80 transition-opacity" data-id="element-376">
                  {product.image.startsWith('http') ? <img src={product.image} alt={product.name} className="w-full h-full object-contain" data-id="element-377" /> : <span className="text-xs text-gray-400 text-center px-2" data-id="element-378">
                      Product Image
                    </span>}
                </a>

                {/* Product Details */}
                <div className="flex-grow" data-id="element-379">
                  <a href="#product-gen3-efoot" data-id="element-380">
                    <h3 className="text-lg font-bold text-gray-900 mb-2 hover:text-red-600 transition-colors" data-id="element-381">
                      {product.name}
                    </h3>
                  </a>
                  <div className="mb-4" data-id="element-382">
                    <span className="text-sm text-gray-600 font-semibold" data-id="element-383">
                      Your Price
                    </span>
                    <p className="text-2xl font-black text-gray-900" data-id="element-384">
                      {product.price}
                    </p>
                  </div>

                  <div className="flex items-center gap-3" data-id="element-385">
                    <div className="flex items-center gap-2" data-id="element-386">
                      <label htmlFor={`qty-${index}`} className="text-sm font-bold text-gray-700" data-id="element-387">
                        Qty
                      </label>
                      <input type="number" id={`qty-${index}`} defaultValue="1" min="1" className="w-16 px-2 py-1 border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-388" />
                    </div>
                    <a href="#product-gen3-efoot" data-id="element-389">
                      {product.hasConfigurator ? <Button variant="primary" className="!py-2 !px-4 text-sm" data-id="element-390">
                          Select Options
                        </Button> : <Button variant="primary" className="!py-2 !px-4 text-sm bg-red-600 hover:bg-red-700 focus:ring-red-600" data-id="element-391">
                          Add To Cart
                        </Button>}
                    </a>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-392" />
    </div>;
}